/*
  steam价格历史查询
  @date 2020-11-05
  @author wanghui@gwdang.com
 */
import PriceHistory from '../../Service/PriceHistory'
import echarts from '../../js/echarts-4.8.0.min'
import { BrowserType } from '../../js/utils/BrowserType'

const tpl = $('#tpl_now').text();
let steamChart = echarts.init(document.getElementById('steam-history-chart'));

// 插件下载，根据不同浏览器
let browser = BrowserType();
if (browser.utype === 'chrome') {
    $('.navigator .download-ext').attr('href', '/app/extension?page=question&guide=chrome');
} else if (browser.utype === 'qq') {
    $('.navigator .download-ext').attr('href', '/app/extension?page=question&guide=qq');
} else {
    $('.navigator .download-ext').attr('href', browser.url.replace('http://', 'https://'));
}

// 新版本Safari跳转到AppStore
if (navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') === -1) {
    $('.navigator .download-ext').attr('href', 'https://itunes.apple.com/cn/app/id1437241336');
}
// 猎豹6、7版本处理
if (navigator.userAgent.indexOf('LBBROWSER') > -1) {
    if (navigator.userAgent.indexOf('LBBROWSER/') > -1) {
        // 猎豹7用QQ原来的
        $('.navigator .download-ext').attr('href', 'https://pcbrowser.dd.qq.com/pcbrowserbig/qbextension/update/20190113/ffbnaibchmeoeglpjahiegilahgfcggm.crx');
    }
}

if (dp_id) {
    PriceHistory.get(dp_id).then(res => {
        const s = res.series[1];
        if (s) {
            $('.card.dp-info .card-body .price-list .current-price > span').html(parseFloat(s.current / 1e2).toFixed(2));

            let option = getChartsOption(s);
            $('.card.price-history .card-body .status-txt').html(PriceHistory.getPriceStatus(s.trend));
            let statusClass = '';
            if (Number(s.trend) === 1)  statusClass = 'up';
            if (Number(s.trend) === -1) statusClass = 'down';
            if (Number(s.trend) === -2) statusClass = 'lowest';
            $('.card.price-history .card-body .status-icon').addClass(statusClass);
            $('.card.price-history .card-body .price-detail .max-price > span').html(parseFloat(s.max / 1e2).toFixed(2));
            $('.card.price-history .card-body .price-detail .min-price > span:not(.date)').html(parseFloat(s.min / 1e2).toFixed(2));

            const d = new Date(s.min_stamp * 1e3);
            let a = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
            if (a[1] < 10) a[1] = '0'+a[1];
            if (a[2] < 10) a[2] = '0'+a[2];
            $('.card.price-history .card-body .price-detail .min-price .date').html(a.join('.'));
            steamChart.setOption(option);
        }

    }).catch(err => {
        console.error(err);
        $('.card.dp-info, .card.price-history').hide();
        $('.card.dp-info.not-found').show();
    })
}

function getChartsOption (data) {
    let seriesData = [];
    const max = parseFloat(data.max / 1e2).toFixed(2);
    const min = parseFloat(data.min / 1e2).toFixed(2);
    let yMin = Math.floor(min * .75);
    let yMax = Math.ceil(max * 1.25);
    let d = Math.ceil((yMax - yMin) / 6);

    data.data.forEach((v) => {
        seriesData.push([
            v.x * 1e3,
            parseFloat(v.y / 1e2).toFixed(2)
        ]);
    });

    const cnt = seriesData.length;
    let t = [seriesData[0]];
    let prev = seriesData[0];
    for (let i = 1; i < cnt; ++i) {
        let current = seriesData[i];
        while (prev[0] + 86400 * 1e3 < current[0]) {
            prev =  [prev[0] + 86400 * 1e3, prev[1]];
            t.push(prev);
        }
        t.push(current);
        prev = current;
    }
    seriesData = t;

    let option = {
        grid: {
            left: '8%',
            right: '8%',
            bottom: 30,
            top: '9.5%',
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'none'
            },
            textStyle: {
                color: '#BDD9F3',
                fontSize: 12,
            },
            backgroundColor: 'rgba(20, 37, 55, .8)',
            extraCssText: 'box-shadow: 0 3px 8px 0 #2A333D;',
            formatter: function (params) {
                const value = params[0].value;
                const d = new Date(value[0]);
                let a = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
                if (a[1] < 10) a[1] = '0'+a[1];
                if (a[2] < 10) a[2] = '0'+a[2];
                return a.join('.') + '<br>' + '价格：￥' + parseFloat(value[1]).toFixed(2);
            },
        },
        xAxis: {
            // type: 'time',
            type: 'category',
            boundaryGap: false,
            axisTick: {
                show: false
            },
            axisLine: {
                show: false
            },
            // interval: 86400 * 1e3 * 30,
            axisLabel: {
                showMinLabel: false,
                showMaxLabel: false,
                color: 'rgba(146, 171, 194, 1)',
                interval: function (index) {
                    const l = seriesData.length;
                    if (index === l - 1 || index === 0)
                        return false;
                    if (l > 100) return index % 20 === 0;
                    if (l > 50) return index % 10 === 0;
                    if (l > 20) return index % 4 === 0;
                    return index % 2 === 0
                },
                formatter: function (value) {
                    let date = new Date(value);
                    let texts = [(date.getMonth() + 1), date.getDate()];
                    if (texts[0] < 10) texts[0] = '0'+texts[0];
                    if (texts[1] < 10) texts[1] = '0'+texts[1];
                    return texts.reverse().join('/');
                }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(62, 76, 90, 1)'
                },
            }
        },
        yAxis: {
            type: 'value',
            name: '价格(元)',
            boundaryGap: false,
            nameTextStyle: {
                color: 'rgba(146, 171, 194, 1)',
                align: 'right'
            },
            axisTick: {
                show: false
            },
            axisLine: {
                show: false
            },
            axisLabel: {
                color: 'rgba(146, 171, 194, 1)',
                formatter: function (value) {
                    return parseFloat(Math.ceil(value)).toFixed(2)
                }
            },
            splitLine: {
                lineStyle: {
                    color: 'rgba(62, 76, 90, 1)'
                }
            },
            interval: d,
            min: yMin,
            max: yMax
        },
        series: [{
            type: 'line',
            data: seriesData,
            lineStyle: {
                color: 'rgba(97, 187, 239, 1)',
                width: 2,
            },
            symbol: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABEElEQVQ4Ea1VvQ6CMBCu4UmML8FENCbOOiA4O/gEPpGD0MrzuDkwEVkIi0GHmg8pqaWC0SO59HI/3/V+ejBm+XzOnWWUTkJRzAORhz6/bkHgIYMONhbXrsjnxXh9yjeByHd9BBvYdhEaiZRyFCSZ2wdi1SWZC98O8E9gKoskc98AcXVb9IUoD9O4unjx4wYCD5nNtk0fxTVrtuLlfhZVZ+94lzaCDjY68Kum3GHomK4A3wemAsDG9AMWa0aj7ShSUk5Dp5k+sBhmS49U1+xDqmYA2Oq+wGLNwLY3rBvwJSBsdUBg0QOSp0zeFPKxIR9svEHSp6ceNelyACj5+lI3RfrmstCHV/GDC1YB4vznF/AEoXhR7of80XoAAAAASUVORK5CYII=',
            showSymbol: false,
        }]
    };

    return option;
}
